<div>
  <div class="text-right mb-2">
    <div *ngIf="isDisabled" class="button text-uppercase btn-green" (click)="isDisabled=false">
      {{"EDIT_ORDER" |translate}}</div>
    <span *ngIf="!isDisabled">
      <div class="button text-uppercase btn-grey mr-3" (click)="isDisabled=true">{{"CANCEL" |translate}}</div>
      <div class="button text-uppercase btn-green" (click)="saveOrdering()">{{"SAVE" |translate}}</div>
    </span>
    <div class="btn-info button ml-3 text-uppercase" (click)="openModalCreate()">{{"CREATE" |translate}}</div>
  </div>


  <div cdkDropList #pendingList="cdkDropList" [cdkDropListData]="customersIds" (cdkDropListDropped)="drop($event)">
    <div class="row-drag flex-space-between" *ngFor="let id of customersIds" cdkDrag [cdkDragDisabled]="isDisabled">
      <div class="row-content">
        <img class="mr-3 cursor-drag d-inline-b" *ngIf="!isDisabled" src="./assets/img/drag.svg" width="16">
        <div class="d-inline-b v-middle w-50">
          <div *ngFor="let item of getCustomerById(id); let last = last" [ngClass]="{'mb-2': !last}">
            <img [src]="getFlag(item.lang)" width="20">
            {{item.description}}
          </div>
        </div>
        <span class="d-inline-b w-50 img-wrap">
          <img class="bg-white p-1" [src]="getImage(getCustomerById(id)[0])" height="30">
        </span>
      </div>
      <span class="v-top">
        <img class="ml-3 cursor" (click)="showModalEdit(id)" src="./assets/img/pencil.svg" width="20">
        <img class="ml-3 mr-3 cursor" src="./assets/img/picture.svg" width="20" (click)="showModalImage(id)">
        <img class="cursor" (click)="showModalDelete(id)" src="./assets/img/delete.svg" width="20">
      </span>
    </div>
  </div>



  <!-- <div *ngFor="let id of customersIds" class="row-stripe flex-space-between">
    <div class="row-content v-top">
      <div *ngFor="let item of getCustomerById(id); let last = last" [ngClass]="{'mb-2': !last}">
        <img [src]="getFlag(item.lang)" width="20">
        {{item.description}}
      </div>
    </div>
    <span class="v-top">
      <img class="ml-3 cursor" (click)="showModalEdit(id)" src="./assets/img/pencil.svg" width="20">
      <img class="ml-3 mr-3 cursor" src="./assets/img/picture.svg" width="20" (click)="showModalImage(id)">
      <img class="cursor" (click)="showModalDelete(id)" src="./assets/img/delete.svg" width="20">
    </span>
  </div> -->
</div>


<div class="modal modal-customer" tabindex="-1" role="dialog">
  <div class="modal-dialog" role="document">
    <div class="modal-content">
      <div class="modal-body">
        <div class="modal-title flex-space-between">
          {{"EDIT_CLIENT" | translate}}
          <img class="cursor" src="assets/img/close.svg" width="10" data-dismiss="modal">
        </div>
        <div class="modal-text pt-4">
          <div *ngFor="let item of getCustomerById(selectedId)" class="flex-space-between mb-2">
            <img [src]="getFlag(item.lang)" width="30" class="mr-2">
            <input type="text" [(ngModel)]="item.description" />
          </div>
          <!-- <img [src]="getCustomerById(selectedId)[0].image" /> -->
        </div>
      </div>
      <div class="modal-footer">
        <div class="button btn-grey text-uppercase" data-dismiss="modal">{{"CANCEL" | translate}}</div>
        <div class="button btn-green text-uppercase" data-dismiss="modal" (click)="save()">OK</div>
      </div>
    </div>
  </div>
</div>

<div class="modal delete-customer" tabindex="-1" role="dialog">
  <div class="modal-dialog" role="document">
    <div class="modal-content">
      <div class="modal-body">
        <div class="modal-title red flex-space-between">
          {{"DELETE_CLIENT" | translate}}
          <img class="cursor" src="assets/img/close.svg" width="10" data-dismiss="modal">
        </div>
        <div class="modal-text pt-4">
          {{"SURE_TO_DELETE" | translate}}
          <span *ngFor="let item of getCustomerById(selectedId)">
            <span class="bold" *ngIf="item.lang=='it-IT'">{{item.description}}</span>
          </span>?
        </div>
      </div>
      <div class="modal-footer">
        <div class="button btn-grey text-uppercase" data-dismiss="modal">{{"CANCEL" | translate}}</div>
        <div class="button btn-green text-uppercase" data-dismiss="modal" (click)="deleteCustomer()">OK</div>
      </div>
    </div>
  </div>
</div>

<div class="modal image-customer" tabindex="-1" role="dialog">
  <div class="modal-dialog" role="document">
    <div class="modal-content">
      <div class="modal-body">
        <div class="modal-title flex-space-between">
          {{"EDIT_IMAGE" | translate}}
          <img class="cursor" src="assets/img/close.svg" width="10" data-dismiss="modal">
        </div>
        <div class="modal-text pt-4 flex-around">
          <span *ngFor="let item of getCustomerById(selectedId); let first=first" [ngClass]="{'d-none': !first}">
            <img [src]="getImage(item)" class="img-modal">
          </span>
          <div class="pl-3 pr-3">

            <div class="bold text-uppercase mb-2">{{"EDIT_IMAGE" | translate}}</div>
            <input type="file" class="border-grey cursor" id="fileCustomer">

            <div class="bold text-uppercase button btn-red mt-3 cursor" (click)="removeImage(selectedId)">
              {{"REMOVE_IMAGE" | translate}}</div>
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <div class="button btn-grey text-uppercase" data-dismiss="modal">{{"CANCEL" | translate}}</div>
        <div class="button btn-green text-uppercase" data-dismiss="modal" (click)="saveImage(selectedId)">
          {{"SAVE" | translate}}</div>
      </div>
    </div>
  </div>
</div>